import { styled } from 'styled-components'

import { Breakpoints, Shadows } from '@b-stock/fe-core/design-system'

import StyledScroll from '@/components/common/modal/scrollbarStyles'

export const ModalContent = styled.div<{
  $size?: 'default' | 'tall'
}>`
  max-height: ${({ $size }) => ($size === 'tall' ? 50 : 25)}dvh;
  overflow: auto;
  padding: 1rem 1.5rem;

  ${StyledScroll}

  @media ${Breakpoints.min.large} {
    padding: 1.5rem 3rem;
  }
`

export const ModalFooter = styled.div`
  ${Shadows.Top};
`
